import { cardTitle } from '../../material-dashboard-pro-react.jsx';

const userFormsStyle = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
  },
};

export default userFormsStyle;
